const elementName = 'aceii-product-accordion';

if (
  typeof window !== 'undefined'
  && typeof HTMLElement !== 'undefined'
  && !window.customElements.get(elementName)
) {
  class AceiiProductAccordion extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.items = [...this.querySelectorAll('[data-product-accordion-item]')];
      const { signal } = this.abortController;

      this.items.forEach((item, index) => {
        const button = item.querySelector('[data-product-accordion-button]');
        if (!button) return;

        button.setAttribute(
          'aria-expanded',
          String(item.hasAttribute('data-open')),
        );
        button.addEventListener(
          'click',
          () => this.setActive(index),
          { signal },
        );
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    setActive(activeIndex) {
      this.items.forEach((item, index) => {
        const active = index === activeIndex && !item.hasAttribute('data-open');
        const button = item.querySelector('[data-product-accordion-button]');

        item.toggleAttribute('data-open', active);
        button?.setAttribute('aria-expanded', String(active));
      });
    }
  }

  window.customElements.define(elementName, AceiiProductAccordion);
}
